angular.module('aprima-core-ui')
    .directive('apDashboardTileHeader', ['$window', '_', function ($window, _) {
        'use strict';

        var requestAnimationFrame = window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            function (callback) {
                $window.setTimeout(callback, 1000/60);
            };

        //taken from headroom.js. utilizes requestAnimationFrame and prevents multiple scroll events from executing on top of each other.
        //initialize with a a callback function, and attach handleEvent to event listeners to debounce the listener
        function Debouncer(callback) {
            this.callback = callback;
            this.ticking = false;
            this.requestedDuringTick = false;
        }

        Debouncer.prototype = {
            constructor: Debouncer,

            update: function () {
                if (this.callback) {
                    this.callback();
                }

                this.ticking = false;

                //execute at trailing edge of debounce
                if(this.requestedDuringTick){
                    this.requestedDuringTick = false;
                    this.requestTick();
                }
            },
            requestTick: function () {
                if (!this.ticking) {
                    requestAnimationFrame(this.rafCallback || (this.rafCallback = this.update.bind(this)));
                    this.ticking = true;
                }
                else{
                    this.requestedDuringTick = true;
                }
            },
            handleEvent: function () {
                this.requestTick();
            }
        };


        function DashboardHeader(elem, watchElementSelector, options) {
            options = _.defaults(options, DashboardHeader.defaultOptions);

            this.lastY = 0;
            this.element = elem;
            this.watchElementSelector = watchElementSelector;

            this.scroller = options.scroller;
            this.topOffset = options.topOffset;
            this.bottomOffset = options.bottomOffset;
            this.scrollUpClass = options.scrollUpClass;
            this.scrollDownClass = options.scrollDownClass;
            this.affixedClassName = options.affixedClassName;

            var debouncer = new Debouncer(this.update.bind(this));
            this.debouncedUpdate = debouncer.handleEvent.bind(debouncer);
        }

        DashboardHeader.defaultOptions = {
            topOffset: 0,
            bottomOffset: 0,
            scroller : $window,
            scrollUpClass: 'scrolled-up',
            scrollDownClass: 'scrolled-down',
            affixedClassName: 'dashboard-heading-affix'
        };

        DashboardHeader.prototype = {
            constructor: DashboardHeader,
            getWatchElement: function() {
                if(!this.__watchElement) {
                    var watchElement = angular.element(this.watchElementSelector);

                    //keep trying to find it if we there werent any results
                    if(watchElement.length) {
                        this.__watchElement = watchElement[0];
                    }
                }
                return this.__watchElement;
            },
            isElementInViewport: function () {
                var watchElement = this.getWatchElement();

                if(!watchElement) {
                    return false;
                }

                var rect = watchElement.getBoundingClientRect();

                //apply class when top of the element is above the viewport and when the bottom of the element is below the top of the viewport (can be outside of viewport)
                return rect.top < (0 + this.topOffset) && rect.bottom >= (0 + this.bottomOffset);
            },
            toggleIsVisibleClass: function () {
                this.element.toggleClass(this.affixedClassName, this.isElementInViewport());
            },
            getScrollY : function() {
                return (this.scroller.pageYOffset !== undefined) ? this.scroller.pageYOffset : (this.scroller.scrollTop !== undefined) ? this.scroller.scrollTop : (document.documentElement || document.body.parentNode || document.body).scrollTop;
            },
            //TAKEN FROM headroom.js
            getViewportHeight : function () {
                return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            },
            /** TAKEN FROM headroom.js
             * Gets the height of the document
             * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
             * @return {int} the height of the document in pixels
             */
            getDocumentHeight : function () {
                var body = document.body,
                    documentElement = document.documentElement;

                return Math.max(
                    body.scrollHeight, documentElement.scrollHeight,
                    body.offsetHeight, documentElement.offsetHeight,
                    body.clientHeight, documentElement.clientHeight
                );
            },

            /** TAKEN FROM headroom.js
             * Gets the height of the DOM element
             * @param  {Object}  elm the element to calculate the height of which
             * @return {int}     the height of the element in pixels
             */
            getElementHeight : function (elm) {
                return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
            },

            /** TAKEN FROM headroom.js
             * Gets the height of the scroller element
             * @return {int} the height of the scroller element in pixels
             */
            getScrollerHeight : function () {
                return (this.scroller === window || this.scroller === document.body) ? this.getDocumentHeight() : this.getElementHeight(this.scroller);
            },

            /** TAKEN FROM headroom.js
             * determines if the scroll position is outside of document boundaries
             * @param  {int}  currentScrollY the current y scroll position
             * @return {bool} true if out of bounds, false otherwise
             */
            isOutOfBounds : function (currentScrollY) {
                var pastTop  = currentScrollY < 0,
                    pastBottom = currentScrollY + this.getViewportHeight() > this.getScrollerHeight();

                return pastTop || pastBottom;
            },
            updateScrollPosition: function () {
                var currentScrollY = this.getScrollY();

                if(this.isOutOfBounds(currentScrollY)) { // Ignore bouncy scrolling in OSX
                    return;
                }
                //100 is the tolerance.up from the patientHeaderTile.html (must be negative in if statement), 0 is the tolerance.down
                if(currentScrollY-this.lastY<=-100 || currentScrollY-this.lastY>0) {
                    var scrolledDown = currentScrollY >= this.lastY;

                    if (scrolledDown) {
                        this.element.addClass(this.scrollDownClass);
                        this.element.removeClass(this.scrollUpClass);
                    }
                    else {
                        this.element.removeClass(this.scrollDownClass);
                        this.element.addClass(this.scrollUpClass);
                    }
                }

                this.lastY = currentScrollY;
            },
            update: function () {
                this.toggleIsVisibleClass();
                this.updateScrollPosition();
            }
        };

        var link = function ($scope, element, attrs) {
            var elm = element.children('.panel-header-sticky'),
                scroller = document.getElementById($scope.apScroller) || window,
                watchElementSelector = attrs.apIsVisibleForElement,
                options = {
                    scroller: scroller,
                    topOffset: parseInt(attrs.apIsVisibleTopOffset) || 0,
                    bottomOffset: parseInt(attrs.apIsVisibleBottomOffset) || 0,
                    scrollUpClass: attrs.apOnScrollUpClass,
                    scrollDownClass: attrs.apOnScrollDownClass,
                    affixedClassName: attrs.apIsVisibleClass
                };

            var header = new DashboardHeader(elm, watchElementSelector, options);
            header.update();

            // when scrolled or collapse or expand a tile, then update the 'scrolled-up' or 'scrolled-down'
            // class and then add or remove class that will fix the tile header to the top
            scroller.addEventListener('scroll', header.debouncedUpdate);
            $scope.toggle = function toggle() {
                header.debouncedUpdate();
                $scope.toggleTile();
            };

            $scope.$on('$destroy', function () {
                scroller.removeEventListener('scroll', header.debouncedUpdate);
                elm = header = null;
            });
        };

        return {
            restrict: 'E',
            templateUrl: '/core-ui/views/directives/apDashboardTileHeader.html',
            transclude: true,
            scope: {
                apScroller: '=',
                toggleTile: '&',
            },
            link: link
        };
    }]);
